module.exports = __webpack_public_path__ + "static/img/bg2.70dbdc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/bg2.jpg
// module id = ShSX
// module chunks = 9